import React from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../../store';
import SliderListItem from '../../../../../../list-items/SliderListItem';
import { previewHistoryBatch } from '../../../../store/extensions';
import { PARTICLE_COUNT_MULTIPLIER, MAX_TOTAL_PARTICLE_COUNT } from '../../../../CreatePageConstants';

const ParticlesSpawnRateListItem = (props) => {
    const { index, particlesBirthRate, updateParticleElement, itemsCount } = props;

    // The slider works in "Count" units (birthRate * PARTICLE_COUNT_MULTIPLIER) so users see a
    // concrete particle number, but we keep storing the raw birthRate.
    // SliderListItem divides the committed value back by displayMultiplier.
    const onCountChange = (value) => {
        previewHistoryBatch.start();
        updateParticleElement(index, { birthRate: value });
    };

    // The 2500 particle budget is shared across every type, so each type's max Count shrinks as
    // more types are added (1 type -> 2500, 2 -> 1250, ...). Keeps the combined total <= the cap.
    const maxCount = Math.floor(MAX_TOTAL_PARTICLE_COUNT / Math.max(1, itemsCount));

    return (
        <SliderListItem
            title='Count'
            value={particlesBirthRate}
            displayMultiplier={PARTICLE_COUNT_MULTIPLIER}
            min={0}
            max={maxCount}
            step={1}
            onValueChange={onCountChange}
            toolTip={'Approximate number of particles on screen. Set to 0 to disable this particle. Increases during loud audio if "SPEED SHIFT" is enabled.'}
        />
    );
};

const mapStateToProps = (state, ownProps) => {
    const items = state.createPreview.present.videoSettings.elements.particles.items;
    const particleElement = items[ownProps.index];

    return {
        particlesBirthRate: particleElement.birthRate,
        itemsCount: items.length
    };
}

const mapDispatchToProps = (dispatch) => {
    const updateParticleElement = (index, properties) => dispatch(createActions.updateParticleElement(index, properties));
    return { updateParticleElement }
}

export default connect(mapStateToProps, mapDispatchToProps)(ParticlesSpawnRateListItem);